import "../styles/genAIJobRoles.css";
import {
  FaRobot,
  FaBrain,
  FaCogs,
  FaNetworkWired,
  FaCodeBranch,
  FaLightbulb,
  FaFlask
} from "react-icons/fa";

export default function AgenticAIJobRoles() {
  const roles = [
    { title: "Agentic AI Engineer", icon: <FaRobot /> },
    { title: "AI Agent Developer", icon: <FaCodeBranch /> },
    { title: "Machine Learning Engineer", icon: <FaBrain /> },
    { title: "AI Automation Engineer", icon: <FaCogs /> },
    { title: "LLM Application Developer", icon: <FaNetworkWired /> },
    { title: "AI Solutions Engineer", icon: <FaLightbulb /> },
    { title: "AI Research Engineer", icon: <FaFlask /> }
  ];

  return (
    <section className="genai-roles-page">
      <div className="roles-container">

        {/* HEADER */}
        <div className="roles-header">
          <h2>
            Program Key <span>Job Roles</span>
          </h2>
          <p>
            Career opportunities after completing the
            <strong> Agentic AI Career Track</strong>
          </p>
        </div>

        {/* ROLES GRID */}
        <div className="roles-grid">
          {roles.map((role, index) => (
            <div className="role-card" key={index}>
              <div className="role-icon">{role.icon}</div>
              <h4>{role.title}</h4>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}